export enum LogicOperatorKind {
    AND = 0,
    OR = 1
}
